import { Box, IconButton } from "@mui/material";
import clsx from "clsx";
import useStyles from "./index.styles";
import maleIcon from "../../assets/imgs/landing/male.png";
import femaleIcon from "../../assets/imgs/landing/female.png";

interface GenderSelectorProps {
  selectedGender: number;
  onSelectGender: (gender: number) => void;
}

export const GenderSelector = ({
  selectedGender,
  onSelectGender,
}: GenderSelectorProps) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.genderSwitch}>
      <Box className={classes.genderContainer}>
        <IconButton
          className={
            selectedGender === 0
              ? clsx(classes.genderButton, classes.genderSelected)
              : classes.genderButton
          }
          color="primary"
          aria-label="Male"
          onClick={() => onSelectGender(0)}
        >
          <Box component="img" src={maleIcon} className={classes.genderIcon} />
        </IconButton>
        <Box>Male</Box>
      </Box>

      <Box className={classes.genderContainer}>
        <IconButton
          className={
            selectedGender === 1
              ? clsx(classes.genderButton, classes.genderSelected)
              : classes.genderButton
          }
          color="primary"
          aria-label="Female"
          onClick={() => onSelectGender(1)}
        >
          <Box
            component="img"
            src={femaleIcon}
            className={classes.genderIcon}
          />
        </IconButton>
        <Box>Female</Box>
      </Box>
    </Box>
  );
};
